import { render, staticRenderFns } from "./entrance.vue?vue&type=template&id=6ec95597&scoped=true&"
import script from "./entrance.vue?vue&type=script&lang=js&"
export * from "./entrance.vue?vue&type=script&lang=js&"
import style0 from "./entrance.vue?vue&type=style&index=0&id=6ec95597&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec95597",
  null
  
)

export default component.exports